/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chart_No_DataInputs */



/**
* | output |
* | --- |
* | "No Data" |
*
* @param {Chart_No_DataInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chart_no_data = /** @type {((inputs?: Chart_No_DataInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chart_No_DataInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("No Data")
});